import { KeyValue } from "@/main/models/common";
import { BodyshopTypes, BodyshopActionTypes } from "./bodyshopTypes";
import { BodyShopFilterRequest } from "@/main/models/request/bodyshopRequest";

export function getBodyshops(request: BodyShopFilterRequest, keyReducer: string = "default"): BodyshopActionTypes {
	return {
		type: BodyshopTypes.GET_BODYSHOPS,
		payload: { request, keyReducer },
	};
}

export function saveBodyshops(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
	keyReducer: string = "default",
): BodyshopActionTypes {
	return {
		type: BodyshopTypes.SAVE_BODYSHOPS,
		payload: { data, isError, errorMessages, keyReducer },
	};
}

export function resetReducerBodyshops(): BodyshopActionTypes {
	return {
		type: BodyshopTypes.RESET_REDUCER_BODYSHOPS,
	};
}
